module.exports = __webpack_public_path__ + "static/img/interactionLive06.6652008.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interactionLive06.png
// module id = fM39
// module chunks = 0